import { Divider } from 'antd'
import { RightOutlined } from '@ant-design/icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClipboard } from "@fortawesome/pro-regular-svg-icons"
import { ConsultationCalendarEvent } from "../scheduleApi"
import dayjs, { Dayjs } from 'dayjs'

type Props = {
  consultation: ConsultationCalendarEvent
  date: Dayjs
  isHovered: boolean
  onMouseEnter: () => void
  onMouseLeave: () => void
  onClick?: () => void
}

const formatAddress = (customer: ConsultationCalendarEvent["customer"]) => {
  if (!customer) {
    return null
  }

  const parts: string[] = []

  if (customer.address1) {
    parts.push(customer.address1)
  }

  const cityStateZip = [customer.city, customer.state].filter(Boolean).join(", ")
  if (cityStateZip || customer.zip) {
    parts.push([cityStateZip, customer.zip].filter(Boolean).join(" "))
  }

  return parts.join(", ")
}

const DayViewConsultation = ({ consultation, isHovered, onMouseEnter, onMouseLeave, onClick }: Props) => {
  const borderColor = consultation.organizerColor || '#e0e0e0'

  const addressString = formatAddress(consultation.customer)

  const formatTimeRange = () => {
    if (consultation.allDay) {
      return 'All Day'
    }
    const startTime = dayjs(consultation.start)
    const endTime = dayjs(consultation.end)
    return `${startTime.format('h:mm A')} - ${endTime.format('h:mm A')}`
  }

  return (
    <div
      style={{
        margin: '4px 16px',
        padding: '10px 12px',
        backgroundColor: 'white',
        borderRadius: '8px',
        borderTop: '1px solid #e8e8e8',
        borderRight: '1px solid #e8e8e8',
        borderBottom: '1px solid #e8e8e8',
        borderLeft: `8px solid ${borderColor}`,
        cursor: onClick ? 'pointer' : 'default',
        boxShadow: isHovered ? '0 0 8px 1px rgba(250, 173, 20, 0.3)' : 'none',
        transition: 'box-shadow 0.2s, transform 0.2s',
        transform: isHovered ? 'scale(1.02)' : 'scale(1)',
      }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
        <div style={{ fontSize: '15px', fontWeight: '600', color: '#000' }}>
          {consultation.customer.displayName || 'Customer'}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {onClick && (
            <div
              style={{
                width: '28px',
                height: '28px',
                borderRadius: '8px',
                border: '1px solid #d9d9d9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <RightOutlined style={{ color: '#999', fontSize: '12px' }} />
            </div>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: '13px', color: '#999' }}>
          <FontAwesomeIcon icon={faClipboard} style={{ fontSize: 13 }} />
          <span>CONSULTATION</span>
        </div>
        <span style={{ fontSize: '14px', color: '#666' }}>
          {formatTimeRange()}
        </span>
      </div>

      {addressString && (
        <>
          <Divider style={{ margin: '8px 0' }} />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: '14px', color: '#666' }}>
              {addressString}
            </div>
            {!onClick && (
              <div
                style={{
                  width: '28px',
                  height: '28px',
                  borderRadius: '8px',
                  border: '1px solid #d9d9d9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <RightOutlined style={{ color: '#999', fontSize: '12px' }} />
              </div>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default DayViewConsultation
